import sample_1 from './dynamic_flex.jpg';

export const dynamicFlexImpressions = {
    sample_1,
};
